module.exports = __webpack_public_path__ + "static/media/login.8531598b.svg";